import React, { useState } from 'react'
import { Button as AntdBtn, Input, message } from 'antd'
import api, { customPhotoUploadApi } from '../../api'

export default function ViewImage({ path, setPath, docEntry, type = '' }) {
	const handleFileChange = (event, index) => {
		const updatedPath = [...path]
		updatedPath[index].file = event.target.files[0]
		setPath(updatedPath)
	}

	const uploadImg = async (index) => {
		const image = path[index]
		const updatedPath = [...path]
		updatedPath[index].uploadLoading = true
		setPath(updatedPath)

		if (!image.file) {
			message.error('Фотография не выбрано')
			return
		}

		const formData = new FormData()
		formData.append('file', image.file)

		const generateRandomKey = () => {
			const characters =
				'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
			let randomKey = ''
			for (let i = 0; i < 16; i++) {
				randomKey += characters.charAt(
					Math.floor(Math.random() * characters.length),
				)
			}
			return randomKey
		}

		const randomKey = generateRandomKey()
		const title = 'YourTitle' // Replace with actual title

		formData.append('Title', title)
		formData.append('Key', randomKey)

		try {
			const updatedPath = [...path]
			updatedPath[index].imgLoading = true
			setPath(updatedPath)

			const res = await customPhotoUploadApi.post('assets/upload', formData, {
				headers: { 'Content-Type': 'multipart/form-data' },
			})

			const { key } = res.data
			updatedPath[index].path = key
			setPath(updatedPath)

			message.success('Успешно загружено!')
		} catch (err) {
			message.error('Ошибка загрузки')
		} finally {
			const updatedPath = [...path]
			updatedPath[index].uploadLoading = false
			setPath(updatedPath)
		}
	}

	const viewImage = async (index) => {
		const image = path[index]
		const updatedPath = [...path]
		updatedPath[index].viewLoading = true
		setPath(updatedPath)

		try {
			const res = await customPhotoUploadApi.get(
				`assets/download/${image.path}`,
				{
					responseType: 'blob',
				},
			)

			const url = window.URL.createObjectURL(
				new Blob([res.data], { type: 'image/png' }),
			)

			const link = document.createElement('a')
			link.href = url
			link.setAttribute('download', 'BP.png')
			document.body.appendChild(link)
			link.click()

			document.body.removeChild(link)
			window.URL.revokeObjectURL(url)
		} catch (error) {
			message.error('Ошибка загрузки файла')
		} finally {
			const updatedPath = [...path]
			updatedPath[index].viewLoading = false
			setPath(updatedPath)
		}
	}

	const deleteImage = (index) => {
		const image = path[index]
		const updatedPath = [...path]
		updatedPath[index] = { ...updatedPath[index], deleteLoading: true }
		setPath(updatedPath)

		customPhotoUploadApi
			.delete(`assets/${image.path}`)
			.then(() => {
				const photoId = path
					.map((images) => images.path)
					.filter((p) => p !== image.path)
					.join(',')

				api
					.patch(`Invoices(${docEntry})`, {
						U_PhotoID: photoId,
					})
					.then(() => {
						deleteRow(index)
						message.success('Фотография успешно удалена')
					})
					.catch(() => {
						message.error('Ошибка обновления данных')
					})
			})
			.catch(() => {
				message.error('Ошибка удаления файла')
			})
			.finally(() => {
				const updatedPath = [...path]
				updatedPath[index] = { ...updatedPath[index], deleteLoading: false }
				setPath(updatedPath)
			})
	}
	const addNewRow = () => {
		setPath([
			...path,
			{
				file: null,
				path: '',
				imgLoading: false,
				deleteLoading: false,
				uploadLoading: false,
				viewLoading: false,
			},
		])
	}

	const deleteRow = (index) => {
		console.log('Delete row Worked:', index)
		setPath(path.filter((_, i) => i !== index))
	}

	return (
		<div className="w-full sm:w-[600px]">
			{path.map((image, index) =>
				image.has ? (
					image.path && (
						<div
							key={index}
							className="flex flex-col w-full items-start gap-1  mb-5"
						>
							<div>
								<p className="font-bold">Фото-{index + 1}</p>
							</div>
							<div className="flex items-center flex-col sm:flex-row gap-3">
								<AntdBtn
									onClick={() => viewImage(index)}
									loading={image.viewLoading}
									className="h-10 w-full sm:w-[100px] rounded-lg bg-[#0A4D68] text-white"
								>
									Скачать
								</AntdBtn>
								<AntdBtn
									onClick={() => deleteImage(index)}
									className="h-10 w-full sm:w-[100px] rounded-lg p-2 bg-red-500 text-white"
									loading={image.deleteLoading}
								>
									Удалить
								</AntdBtn>
								{index === path.length - 1 && (
									<AntdBtn
										onClick={addNewRow}
										className="h-10 w-full sm:w-[100px] rounded-lg bg-[#0A4D68] text-white"
									>
										Добавить
									</AntdBtn>
								)}
							</div>
						</div>
					)
				) : (
					<div
						key={index}
						className="flex flex-col w-full items-start gap-1 mb-5"
					>
						<div>
							<p className="font-bold">Фото-{index + 1}</p>
						</div>
						<div className="flex flex-col sm:flex-row items-center gap-3 ">
							<Input
								type="file"
								onChange={(e) => handleFileChange(e, index)}
								className="w-full"
							/>
							<AntdBtn
								onClick={() => uploadImg(index)}
								loading={image.uploadLoading}
								className="h-10 w-full sm:w-[100px] rounded-lg bg-[#0A4D68] text-white"
							>
								Загрузить
							</AntdBtn>
							{image.path && (
								<>
									<AntdBtn
										onClick={() => viewImage(index)}
										loading={image.viewLoading}
										className="h-10 w-full sm:w-[100px] rounded-lg bg-[#0A4D68] text-white"
									>
										Скачать
									</AntdBtn>
									<AntdBtn
										onClick={() => deleteImage(index)}
										loading={image.deleteLoading}
										className="h-10 w-full sm:w-[100px] rounded-lg p-2 bg-red-500 text-white"
									>
										Удалить
									</AntdBtn>
								</>
							)}
							{index !== 0 && (
								<AntdBtn
									onClick={() => deleteRow(index)}
									className="h-10 w-full sm:w-[100px] rounded-lg p-2 bg-red-500 text-white"
								>
									Отменить
								</AntdBtn>
							)}
							{index === path.length - 1 && (
								<AntdBtn
									onClick={addNewRow}
									className="h-10 w-full sm:w-[100px] rounded-lg bg-[#0A4D68] text-white"
								>
									Добавить
								</AntdBtn>
							)}
						</div>
					</div>
				),
			)}
		</div>
	)
}
